import React from 'react';
import axios from 'axios';
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';


/**
 * 投稿データを登録するAPIのパスを定義
 * @type {string}
 * */
const URL = "/comment/";

const useStyles = makeStyles((theme) => ({
    root: {
        display: 'flex',
        flexWrap: 'wrap',

    },
    textField: {
        marginTop: theme.spacing(1),
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        '& label.Mui-focused': {
            color: 'darkblue',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                borderColor: 'darkblue',
            },
        },
    },
    button: {
        marginTop: theme.spacing(1),
    }
}));


/**
 * 投稿フォームコンポーネント
 *
 * @param {*} props
 * @return {*} 
 */
const Form = (props) => {

    console.log('@Form.js___----->');

    const classes = useStyles();

    const [post, setPost] = React.useState(props.post);

    const handleChangeName = (event) => {
        setPost({...post, name: event.target.value});
        console.log('@Form.js___handleChangeName----->', post);
    };

    const handleChangeMessage = (event) => {
        setPost({...post, message: event.target.value});
        console.log('@Form.js___handleChangeMessage----->', post);
    };

    const handleSubmit = (event) => {
        console.log('@Form.js___handleSubmit----->');
        console.log('@Form.js___handleSubmit_window.parent.location.href----->', window.parent.location.href);

        // 親URL取得
        let parent = window.parent.location.href;
        // パスパラメータ初期化
        let path = "";

        // 親URLからパスパラメータ取得(bodyに設定)
        if(parent) {
            let array = parent.split('/')
            if(array.indexOf("post") !== -1) {
                console.log('@Form.js___handleSubmit: post str is exist. indexOf----->', array.indexOf("post"));
                path = array[array.indexOf("post") + 1]
                console.log('@Form.js___handleSubmit: path----->', path);
            }
        }

        event.preventDefault();

        if(post.name === '') {
            post.name = '名無しさん'
        }

        let body = {
            name: post.name,
            message: post.message,
            path: path
        }

        props.setViewState('LOADING');

        axios.post(URL, body).then(res => {
            console.log("@Form.js___handleSubmit_axios_success------->");
            props.onSubmitPost({
                id: res.data.id,
                date: res.data.date,
                name: res.data.name,
                message: res.data.message,
            });

            props.setViewState('READY');

            setPost({
                ...post,
                name: '名無しさん',
                message: '',
            });
        }).catch(error => {
            console.log("@Form.js___handleSubmit_axios_failure------->", error);
            props.setViewState('ERROR');
        });

    };

    return (
        
        <form noValidate autoComplete="off" onSubmit={handleSubmit}>
            <div className={classes.root}>
            <TextField
                id="standard-basic"
                label="名前"
                variant="outlined"
                fullWidth
                className={classes.textField}
                value={post.name}
                onChange={handleChangeName}
                disabled={props.state.viewState === 'LOADING'}
            />
            <TextField
                id="standard-multiline-flexible"
                label="本文"
                variant="outlined"
                fullWidth
                className={classes.textField}
                multiline
                rowsMax={10}
                value={post.message}
                onChange={handleChangeMessage}
                disabled={props.state.viewState === 'LOADING'}
            />
            </div>
            <div className={classes.button}>
                <Button
                    type="submit"
                    variant="contained"
                    disabled={props.state.viewState === 'LOADING' || post.message === ''}
                >
                    送信
                </Button>
            </div>
        </form>
    );
}


Form.defaultProps = {
    post: {
        name: '名無しさん',
        message: '',    
    }
}

export default Form;